import { useSelector } from 'react-redux';
import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { selectThemeMode } from '../../../redux/slices/themeSlice';
import { getPlatform } from '../../../common/firebase';
import styled from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../common/responsive';
import { BodyMedium } from '../../../components/Texts';

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  position: relative;
  z-index: 1;
  min-height: 250px;
  @media ${PHONE_MEDIA_QUERY} {
    min-height: 0px;
    padding-top: 40px;
  }
`;

const StoreImage = styled.img`
  max-width: 200px;
  height: auto;
  cursor: pointer;
  transition: opacity 0.2s ease;

  @media (hover: hover) {
    &:hover {
      opacity: 0.8;
    }
  }
`;

const StoresContainer = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: row;
`;

const BlueCircle = styled.div`
  position: absolute;
  z-index: 0;
  width: 1000px;
  height: 1000px;
  pointer-events: none;
  top: -700px;
  background: red;
  background: radial-gradient(
    circle,
    ${({ theme }) => theme.primary.primary}50 0%,
    ${({ theme }) => theme.primary.primary}00 70%
  );
  border-radius: 50%;
  @media ${PHONE_MEDIA_QUERY} {
    background: radial-gradient(
      circle,
      ${({ theme }) => theme.primary.primary}40 0%,
      ${({ theme }) => theme.primary.primary}00 50%
    );
  }
`;

const DownloadAppModal = ({ onClose }) => {
  const themeMode = useSelector(selectThemeMode);
  const platform = getPlatform();
  const isAndroid = platform === 'android';
  const isIOS = platform === 'ios';
  const isDark = themeMode === 'dark';

  const openPlayStore = () => {
    window.open(
      'https://play.google.com/store/apps/details?id=xyz.deks.app',
      '_blank',
    );
  };

  const openAppStore = () => {
    window.open(
      'https://apps.apple.com/us/app/deks-xyz/id6749857801',
      '_blank',
    );
  };

  const getImageSrc = () => {
    if (isAndroid) {
      return isDark
        ? '/download/playstore-dark.webp'
        : '/download/playstore-light.webp';
    } else if (isIOS) {
      return isDark
        ? '/download/appstore-dark.webp'
        : '/download/appstore-light.webp';
    } else {
      // Show both for unknown platforms
      return null;
    }
  };

  const getBothImages = () => {
    return (
      <>
        <StoreImage
          onClick={openPlayStore}
          src={
            isDark
              ? '/download/playstore-dark.webp'
              : '/download/playstore-light.webp'
          }
          alt='Get it on Google Play'
        />
        <StoreImage
          onClick={openAppStore}
          src={
            isDark
              ? '/download/appstore-dark.webp'
              : '/download/appstore-light.webp'
          }
          alt='Download on the App Store'
        />
      </>
    );
  };

  const imageSrc = getImageSrc();

  return (
    <Modal onClose={onClose} customStyle={{ overflow: 'hidden' }}>
      <InnerContainer>
        <BlueCircle />
        <img
          style={{
            width: '90%',
            maxWidth: '200px',
          }}
          src={
            themeMode === 'light'
              ? '/logo-footer.webp'
              : '/logo-footer-dark.webp'
          }
          alt='Deks Logo'
        />
        <BodyMedium>Download the app to get the full experience.</BodyMedium>
        {imageSrc ? (
          <StoreImage
            onClick={() => {
              if (platform === 'android') {
                openPlayStore();
              } else if (platform === 'ios') {
                openAppStore();
              }
            }}
            src={imageSrc}
            alt={
              platform === 'android'
                ? 'Get it on Google Play'
                : 'Download on the App Store'
            }
          />
        ) : (
          <StoresContainer>{getBothImages()}</StoresContainer>
        )}
      </InnerContainer>
    </Modal>
  );
};

export default DownloadAppModal;
